import chatReducer from "../../pages/Chat/redux/reducer";
import enumsReducer from "./enums";
import listsReducer from "./list";
import paginationReducer from "./pagination";
import userReducer from "./user";
import settingsReducer from "./settings";
import { notificationReducer } from "../../shared/BaseNotificationList";

const rootReducer = {
  pagination: paginationReducer,
  user: userReducer,
  lists: listsReducer,
  enums: enumsReducer,
  chat: chatReducer,
  settings: settingsReducer,
  notifications: notificationReducer,
};

export default rootReducer;
